import { type AllowedColors, Button, colors, Input, Text } from '@innovationdepartment/proxima-ui';
import { FormSection, SaveBar } from '../CastingProfile.styles';
import type { CastingMetadata } from '../CastingProfile.types';
import type useCastingProfileForm from '../useCastingProfileForm';
import AgeSection from './AgeSection';
import AttractivenessField from './AttractivenessField';
import BuildField from './BuildField';

type CastingProfileFormProps = {
  form: ReturnType<typeof useCastingProfileForm>;
  metadata: CastingMetadata;
  saving: boolean;
  onSave: () => void;
};

const CastingProfileForm = ({ form, metadata, saving, onSave }: CastingProfileFormProps) => {
  const { formState, setField, errors, isValid, isDirty } = form;

  return (
    <>
      <FormSection>
        <Text variant="h5">Vibe Summary</Text>
        <Input
          value={formState.vibeSummary}
          onChange={value => setField('vibeSummary', value)}
          error={Boolean(errors.vibeSummary)}
          helperText={errors.vibeSummary}
          placeholder="Describe the brand's on-camera vibe"
          fullWidth
        />
      </FormSection>

      <AgeSection
        ageMin={formState.targetModelAgeMin}
        ageMax={formState.targetModelAgeMax}
        onChangeMin={value => setField('targetModelAgeMin', value)}
        onChangeMax={value => setField('targetModelAgeMax', value)}
        errorMin={errors.targetModelAgeMin}
        errorMax={errors.targetModelAgeMax}
      />

      {/* The casting profile form only deals in adult tiers/builds */}
      <AttractivenessField
        options={metadata.attractivenessLevels.filter(level => level.isAdult)}
        selected={formState.onBrandAttractiveness}
        onChange={value => setField('onBrandAttractiveness', value)}
        error={errors.onBrandAttractiveness}
      />

      <BuildField
        options={metadata.buildTypes.filter(build => build.isAdult)}
        selected={formState.onBrandBuilds}
        onChange={value => setField('onBrandBuilds', value)}
        error={errors.onBrandBuilds}
      />

      <SaveBar>
        <Button
          label={saving ? 'Saving…' : 'Save casting profile'}
          overrideColors={{
            backgroundColor: colors.neutral100,
            textColor: colors.white as AllowedColors
          }}
          onClick={onSave}
          disabled={!isDirty || !isValid || saving}
        />
      </SaveBar>
    </>
  );
};

export default CastingProfileForm;
